import React from 'react';
import StaticPageHeader from '../components/common/StaticPageHeader';
import useMerchantSettings from '../hooks/useMerchantSettings';
import { errorView, loadingView } from '../utils/Utilities';
import { Helmet } from 'react-helmet-async';
import '../assets/css/allpages.css';

const ReturnExchange = () => {
    const { merchantSettings, loading, error } = useMerchantSettings();
    const currentOrigin = typeof window !== 'undefined' ? window.location.origin : '';
    const storeName = merchantSettings?.legal_name || 'Online Store';

    return (
        <div className="static-page-wrapper">
            <Helmet>
                <title>{`Return & Exchange Policy | ${storeName}`}</title>
                <meta name="description" content={`Review the return and exchange policy for ${storeName}. Easy returns, replacements, and refund instructions.`} />
                {currentOrigin && <link rel="canonical" href={`${currentOrigin}/return`} />}
            </Helmet>
            <StaticPageHeader title="Return & Exchange" />
            {loading ? loadingView() : error ? errorView(error) : (
                <div className="container static-page-container">
                    <div className="static-page-content">
                        <div dangerouslySetInnerHTML={{ __html: merchantSettings.merchant_configuration?.return_exchange }} />
                    </div>
                </div>
            )}
        </div>
    )
}

export default ReturnExchange;